module.exports = __webpack_public_path__ + "img/person_niuchaoye.c05d86b4.jpg";